import React, { useCallback, useEffect, useState } from 'react'
import { Loading, GenericList, AirDateFormatter } from '@scrippsproduct/scripps-external-component-library'
import { convert12to24 } from '@scrippsproduct/scripps-external-component-library/dist/utils/helpers'
import { determineProgramTitle } from '@scrippsproduct/scripps-external-component-library/dist/utils/program-helpers'
import { getUpcomingAirDates } from '@scrippsproduct/scripps-external-component-library/dist/utils/getUpcomingPrograms'

const SCHEDULE_ENDPOINT = process.env.REACT_APP_SCHEDULE_V2
const NETWORK = process.env.REACT_APP_NETWORK

function UpcomingModalContainer({ programId, programType = 'series' }) {
    const [nextAirDates, setNextAirDates] = useState([])
    const [seriesTitle, setSeriesTitle] = useState('')
    const [isFeteched, setIsFetched] = useState(false)
    
    const getPrograms = useCallback(() => {
        setIsFetched(false)
        setNextAirDates([])
        ;(async () => {
            const programs = await getUpcomingAirDates({
                programId, 
                programType, 
                maxResults: 10,
                SCHEDULE_ENDPOINT,
                NETWORK
            })

            const airdates = programs.map(progam => (<AirDateFormatter airdateStr={`${progam.start_date_parse} ${convert12to24(progam.start_time)}`}/>))
            setNextAirDates([...airdates])
            if (programs.length) setSeriesTitle(determineProgramTitle(programs[0]))
            setIsFetched(true)
            
        })()
    }, [programId, programType])

    useEffect(() => {
        getPrograms()
    }, [getPrograms])

    return  (<>        
        { (nextAirDates.length > 0) 
            ? 
                <div>
                    <h2 className='h2'>{seriesTitle}</h2>
                    <h3 className='h5'>Upcoming Airings</h3>
                    <GenericList list={nextAirDates} classname={'upcoming'}/>
                </div> 
            : (isFeteched) 
                ? 
                    <p>
                        This show doesn't have any episodes scheduled in the next two weeks. Please check back to see when it will be airing again.<br></br>Or you can view our <a href="/schedule" className="inline-anchor">full schedule</a> to see what shows are airing.
                    </p> 
                : <Loading spinnerColor={`var(--theme-color-500)`} /> 
        }
    </>)
}

export default UpcomingModalContainer